import NavBar from '../components/navBar'
import Footer from '../components/footer'
import React, { useEffect } from 'react'
import api from '../services/api'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export default function TemplateHome({ element: component, footer = true }) {
    const definicoesSistema = useSelector((state) => state.definicoesSistema);
    const dispatch = useDispatch();
    const location = useLocation(); 


    useEffect(() => {
        api.get(`/definicoes/sistema/all`)
            .then(response => {
                dispatch({
                    type: 'definicoesSistema',
                    payload: {
                        definicoesSistema: response.data.definicoesSistema[0],
                    },
                });
            }).catch(err => '')
    }, [dispatch])


    useEffect(() => {
      // Rolar para o topo da página ao carregar um novo caminho
      window.scrollTo(0, 0);
    }, [location]);

    return (
        <div style={{ marginTop: 100 }}>
            <NavBar />
            {/* {component} */}
            {React.cloneElement(component, { definicoesSistema: definicoesSistema })}

            {footer && <Footer />}
        </div>
    )
}
